import { render, staticRenderFns } from "./ModalUserVerification.vue?vue&type=template&id=7d72a18e&"
import script from "./ModalUserVerification.vue?vue&type=script&lang=js&"
export * from "./ModalUserVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports